import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";
import { themeColors } from "pages/Hooks/useCustomTheme";
import { UserType } from "Domain/User/Entity/User";

type UserTypeChipProps = {
  status: UserType;
};

export default function UserTypeChip({ status }: UserTypeChipProps) {
  const { t } = useTranslation();
  const statusColor =
    status in themeColors ? themeColors[status][600] : "white";

  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.user_type.${status}`)}
      info={t(`STATUS.INFO.user_type.${status}`)}
    />
  );
}
